import React from "react";
import { format, fromUnixTime } from "date-fns";
import { USD_DECIMALS } from "lib/legacy";
import "./TradeHistory.css";
import { formatAmount } from "lib/numbers";
import { t, Trans } from "@lingui/macro";
import cx from "classnames";
import { DARK_THEME, GRAY_THEME } from "./constants";
import EmptyRow from "./table/EmptyRow";
import ExchangeTable from "./table/ExchangeTable";
import ExchangeRow from "./table/ExchangeRow";
import ExchangeTokenInfo from "./table/ExchangeTokenInfo";

export default function TradeHistory(props) {
  const { infoTokens, theme, connectWallet, tradeHistory, className } = props;

  const renderHead = () => {
    return (
      <tr className="Exchange-list-header">
        <th className="w-1/5 Start">
          <div>
            <Trans>Position</Trans>
          </div>
        </th>

        <th>
          <div>
            <Trans>Side</Trans>
          </div>
        </th>

        <th>
          <div>
            <Trans>Action</Trans>
          </div>
        </th>

        <th>
          <div>
            <Trans>Type</Trans>
          </div>
        </th>
        <th>
          <div>
            <Trans>Price</Trans>
          </div>
        </th>
        <th>
          <div>
            <Trans>Size</Trans>
          </div>
        </th>
        <th className="End">
          <div>
            <Trans>Date</Trans>
          </div>
        </th>
      </tr>
    );
  };

  return (
    <div
      className={cx(className || "TradeHistory", {
        gray: theme === GRAY_THEME,
        dark: theme === DARK_THEME,
      })}
    >
      <ExchangeTable>
        {renderHead()}
        <EmptyRow connectWallet={connectWallet} items={tradeHistory} msg={t`You don't have any trading activity.`} />
        {tradeHistory.map((item) => (
          <ExchangeRow key={`${item.isLong}-${item.type}-${item.id}`}>
            <td className="Exchange-list-item-type" key={`${item.type}-${item.id}`}>
              <ExchangeTokenInfo infoTokens={infoTokens} token={item.token} leverage={item.leverage} />
            </td>
            <td>
              <div>
                <span className={cx({ long: item.isLong, short: !item.isLong })}>
                  {item.isLong ? t`Long` : t`Short`}
                </span>
              </div>
            </td>
            <td className="Exchange-list-item-type">{item.type}</td>
            <td>{item.action}</td>
            <td>${formatAmount(item.price, USD_DECIMALS, 2, true)}</td>
            <td>${formatAmount(item.size, USD_DECIMALS, 4, true)}</td>
            <td>{format(fromUnixTime(item.timestamp), "PPpp")}</td>
          </ExchangeRow>
        ))}
      </ExchangeTable>
    </div>
  );
}
